"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyTemplateLiveMulti = void 0;
const add_error_1 = __importDefault(require("../ac/add-error"));
const template_apply_live_1 = __importDefault(require("../request/template-apply-live"));
const store_1 = __importDefault(require("../store"));
const is_loading_1 = __importDefault(require("./is-loading"));
const create_ac_1 = require("./util/create-ac");
exports.applyTemplateLiveMulti = (0, create_ac_1.createAC)(async (dispatch, { templateId, targetDates }) => {
    const { auth, workspaceId } = store_1.default.getState();
    if (!workspaceId)
        return;
    await dispatch((0, is_loading_1.default)('apply-template-live'));
    // apply the template
    const result = await (0, template_apply_live_1.default)({
        workspace: workspaceId,
        template: templateId,
        targetDates,
    }, auth);
    if (result?.error) {
        await dispatch((0, add_error_1.default)(result.error));
    }
    await dispatch((0, is_loading_1.default)('apply-template-live', true));
});
